import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import CircleImage from '../components/CircleImage';

export default function AgentsPage() {
const agents = [
  {
    name: 'Matthew Kontos',
    title: 'Owner & Managing Broker',
    license: 'License #471.021736',
    image: 'https://ap.rdcpix.com/1490187338/098e89735970dd6f0ef8f17401c4c305a-e0rd-w260_h260.webp',
    description:
      'As the Owner and Managing Broker of Pembre Realty, I take pride in helping clients make confident real estate decisions. With over eight years of experience, I’ve learned that success in this business comes down to trust, communication, and follow-through. Whether you’re buying your first home or selling an investment property, my goal is to make the process as smooth and stress-free as possible.',
  },
  {
    name: 'Aneta Zaremba',
    title: 'Real Estate Broker',
    license: 'License #	475.215223',
    image: '/pembre-circle.png',
    description:
      'Real estate is more than transactions to me — it’s about people and their goals. I work closely with each client to understand what matters most and tailor my approach to fit their needs. From first-time buyers to seasoned investors, I strive to provide honest guidance, strong negotiation, and a positive experience every time.',
  },
  {
    name: 'Renee Kontos',
    title: 'Real Estate Broker',
    license: 'License #475.215216',
    image: '/pembre-circle.png',
    description:
      'I believe in building relationships that last well beyond the closing table. My clients know me for my attention to detail, responsiveness, and dedication to achieving their real estate goals. Every property and every client is unique, and I take pride in delivering personalized service that makes each experience exceptional.',
  },
];
  return (
    <div className="bg-light py-5 min-vh-100 d-flex align-items-center">
      <Container>
        <h1 className="text-center mb-5 fw-bold">Meet Our Agents</h1>
        <Row xs={1} sm={2} md={3} className="g-4 justify-content-center">
          {agents.map((agent, index) => (
            <Col
              key={index}
              className="d-flex justify-content-center"
              style={{ maxWidth: '320px' }}
            >
              <Card className="text-center shadow-sm border-0 p-3 h-100 rounded-4 w-100">
                <div className="d-flex justify-content-center mt-3 mb-4">
                  <CircleImage src={agent.image} alt={agent.name} size={120} />
                </div>
                <Card.Body>
                  <Card.Title className="fw-semibold">{agent.name}</Card.Title>
                  <Card.Subtitle className="mb-1 text-muted">
                    {agent.title}
                  </Card.Subtitle>
                  <div className="text-muted small mb-2">
                    {agent.license}
                  </div>
                  <Card.Text className="mt-3 text-secondary">
                    {agent.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}